export enum OfferStatus {
    Pending = 1,
    APNQueue = 2,
    APNReview = 3,
    VendorReview = 4,
    ChangeRequested = 5,
    Accepted = 6,
    ContractRequested = 7,
    ContractChange = 8,
    Rescinded = 9,
    Declined = 10,
    RecruiterReview = 11
}

export enum OffersUserType {
    AccountManager = 'account-manager',
    Recruiter = 'recruiter'
}
